import { CartContextForAnalytics } from "./CartContextForAnalytics";

export interface PaymentMethod<T extends PaymentMethodMeta> {
    /** name of payment method */
    name: string;
    /** display value of payment method */
    displayName: string;
    /** payment code to identify payment method */
    paymentCode: string;
    /** To check whether the payment method is enabled to transact */
    enabled: boolean;
    /** Group name in which this payment method exist */
    groupName: string;
    /** Whether coupon is applicable on the payment method */
    couponApplicable: boolean;
    /** Whether reward is applicable on the payment method */
    rewardApplicable: boolean;
    /** Whether the payment method is preferred payment or not */
    preferred?: boolean;
    /** Contains meta information regarding method data such as iconUrl */
    meta: T;
    /** Is split play enabled on payment method */
    splitPayEnabled: boolean;
    /** Preferred payment priority */
    preferredPriority?: number;
}

export interface PaymentMethodMeta {
    /** Icon url to render payment method image */
    iconUrl?: string;
    /** Meta text to render under payment method name */
    promoMsg?: string;
    /** If `disabled`, the message to render the reason */
    disableMessage?: string;
    // account refrence id for in app upi
    referenceId?: string;
    // reward id for twid rewards
    rewardId?: string;
    /** Juspay direct integration token information */
    token?: unknown;
    /** Juspay merchant id for the payment method */
    merchantId?: string;
}

export enum PLACE_ORDER_SOURCE {
    TURBOCHECKOUT = "turbocheckout",
    PAYMENT = "payment",
}

export type OnPayExtraParams = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    place_order_source?: PLACE_ORDER_SOURCE;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
};

export interface OnPayArbitaryData {
    [key: string]: unknown;
    isTurboPaymentMethod?: boolean;
    slidePercent?: number;
    isPaymentMethodFacingDowntime?: boolean;
    isFromTurboPlaceOrder?: boolean;
    isTurboV2?: boolean;
    isRewardApplicable?: boolean;
    cartContextForAnalytics?: CartContextForAnalytics;
}

export interface UpiIntentAppMeta {
    displayName: string;
    packageName: string;
    iconUrl?: string;
}

export interface AllUpiIntentAvailableMethodsResponse {
    upiAppsDetails: UpiIntentAppMeta[];
}
